<div class="grafico-torta">
  <p-chart type="pie" [data]="data()" [options]="pieOptions()" [plugins]="piePlugins" />
</div>
